import { lifecycle, compose, withProps } from 'recompose';
import { List } from 'immutable';

import { Endpoints } from '../lib/LeanLinkService';
import { withFetch } from '../entities/Entity/containers';

export default compose(
  withProps({
    recruitmentStatusIds: new List(),
  }),
  withFetch(),
  lifecycle({
    componentWillMount() {
      const refreshRecruitmentStatuses = () => this.props.fetch({ url: Endpoints.recruitmentStatuses({ sort: 'sort', direction: 'asc' }) })
        .then(({ result }) => {
          const ids = result.items.map(o => o.get('id'));
          this.setState({ recruitmentStatusIds: ids });
        });

      refreshRecruitmentStatuses();
      this.setState({ refreshRecruitmentStatuses });
    },
  }),
);
